import CookieConsentManager from './cookie-consent-manager.js';

const bootCookieConsentManager = () => {
	(new CookieConsentManager()).run(
		window.locomotiveCookieConsentConfig,
		window.locomotiveCookieConsentGtagMap
	);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bootCookieConsentManager);
} else {
	bootCookieConsentManager();
}
